import { Icon } from '@components';
import { Flex } from '@styles';
import styled, { css } from 'styled-components';

export const offlineContentPageLayoutByVariant = {
  desktop: {
    header: {
      left: 0,
      position: 'absolute',
      px: 156,
      right: 0,
    },
    pl: 156,
    pr: 156,
    px: 156,
  },
  laptop: {
    header: {
      left: 0,
      position: 'absolute',
      px: 24,
      right: 0,
    },
    pl: 24,
    pr: 24,
    px: 24,
  },
  mobile: {
    header: {
      left: 0,
      position: 'absolute',
      px: 16,
      right: 0,
    },
    pl: 16,
    pr: 16,
    px: 16,
  },
  tablet: {
    header: {
      left: 0,
      position: 'absolute',
      px: 24,
      right: 0,
    },
    pl: 24,
    pr: 24,
    px: 24,
  },
};

export const profileData = {
  activitiesCompleted: '69',
  finalTestsPassed: '3/14',
  id: 1212,
  name: 'Oleg Vinnyk',
  rank: 'private',
};

export const ongoingModule = {
  description:
    'This course is designed for soldiers, focusing on the practical application of International Humanitarian Law (IHL) in combat situations. It covers the basics of the Geneva Conventions, rules of engagement, and the ethical considerations soldiers must navigate in the field.',
  elements: [
    {
      id: 1,
      text: 'Rules in wartime? What do you think?',
    },
    {
      id: 2,
      text: 'Are there any rules in war?',
    },
    {
      id: 3,
      isActive: true,
      // isAvailableToWatchVideo: true,
      text: 'Understanding of the rules',
    },
    {
      id: 4,
      text: 'Why you should obey these rules',
    },
    {
      id: 5,
      text: `These rules don't apply for me`,
    },
    {
      id: 6,
      text: 'Why should I comply?',
    },
    {
      id: 7,
      isAvailableToPassTest: true,
      text: 'Final test',
    },
  ],
  id: 12,
  image:
    'https://buffer.com/cdn-cgi/image/w=1000,fit=contain,q=90,f=auto/library/content/images/size/w1200/2023/10/free-images.jpg',
  isTest: true,
  lessons: 6,
  minutes_count: 5,
  module: 2,
  peoplePassed: '150k',
  title: 'Principle of Distinction',
};

export const tagsProps = [
  {
    key: 'minutes_count',
    keyTag: 'time',
    translationName: 'ProfilePage.MinutesShort',
  },
  {
    key: 'lessons_count',
    keyTag: 'material',
    translationName: 'ProfilePage.Lessons',
  },
  {
    key: 'isTest',
    keyTag: 'test',
    translationName: 'ProfilePage.Test',
  },
  {
    key: 'passed',
    keyTag: 'peoplePassed',
    translationName: 'ProfilePage.PeoplePassed',
  },
];

export const modulesProps = [
  {
    description:
      'This course is designed for soldiers, focusing on the practical application of International Humanitarian Law (IHL) in combat situations. It covers the basics of the Geneva Conventions, rules of engagement, and the ethical considerations soldiers must navigate in the field.',

    id: 12,
    image:
      'https://buffer.com/cdn-cgi/image/w=1000,fit=contain,q=90,f=auto/library/content/images/size/w1200/2023/10/free-images.jpg',
    isTest: true,
    lessons: 6,
    minutes_count: 5,
    module: 2,
    peoplePassed: '150k',
    title: 'Principle of Distinction',
  },
  {
    description:
      'This course is designed for soldiers, focusing on the practical application of International Humanitarian Law (IHL) in combat situations. It covers the basics of the Geneva Conventions, rules of engagement, and the ethical considerations soldiers must navigate in the field.',

    id: 13,
    image:
      'https://buffer.com/cdn-cgi/image/w=1000,fit=contain,q=90,f=auto/library/content/images/size/w1200/2023/10/free-images.jpg',
    isTest: true,
    lessons: 6,
    minutes_count: 5,
    module: 2,
    peoplePassed: '150k',
    title: '2Principle of Distinction',
  },
  {
    description:
      'This course is designed for soldiers, focusing on the practical application of International Humanitarian Law (IHL) in combat situations. It covers the basics of the Geneva Conventions, rules of engagement, and the ethical considerations soldiers must navigate in the field.',

    id: 122,
    image:
      'https://buffer.com/cdn-cgi/image/w=1000,fit=contain,q=90,f=auto/library/content/images/size/w1200/2023/10/free-images.jpg',
    isTest: true,
    lessons: 6,
    minutes_count: 5,
    module: 2,
    peoplePassed: '150k',
    title: '3Principle of Distinction',
  },
];

export const StyledFlex = styled(Flex)`
  ${({ theme: { colors } }) => css`
    background-color: ${colors.schoolBusYellow[100]};
    div {
      filter: invert(1);
    }
  `}
`;

export const CenterIcon = styled(Icon)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
